export function generateListHTML(items: string[]) {
  let html = items.map(item => `<li>${item}</li>`).join('');
  html = `<ul class="errors">${html}</ul>`;

  return html;
}
